import { PhoneNumber } from '@brightdrop/localization-core';

import { getFormattedPhone } from '~/common/components/table/utils/table.utils';
import { DEFAULT_EMPTY_VALUE } from '~/common/constants/common.constant';
import { useLocalizationFeatureFlag } from '~/features/catalog/hooks/useLocalizationFeatureFlag';

/**
 * A stored phone number laid out for display.
 *
 * With the flag on the number is written nationally on the reader's own calling code and
 * internationally otherwise; off, it keeps the legacy fixed North American format so the field
 * is unchanged until rollout.
 */
const LocalizedPhoneNumber = ({
  phone,
}: {
  phone?: string | null;
}): JSX.Element => {
  const { isEnabled: localizationEnabled } = useLocalizationFeatureFlag();

  if (localizationEnabled) {
    return <PhoneNumber value={phone} />;
  }

  return <>{phone ? getFormattedPhone(phone) : DEFAULT_EMPTY_VALUE}</>;
};

export default LocalizedPhoneNumber;
